enum DocumentStatus {
    UNRECOGNIZED_DOCUMENT = "UNRECOGNIZED_DOCUMENT",
    NO_MATCH = "NO_MATCH",
    MATCH = "MATCH"
}
export default DocumentStatus;
